import { ITOP_TICKET_OPERATIONAL_STATUS_MAP } from '@siptel-web/common';
import React, { useEffect, useRef } from 'react';
import LoadingSpinner from 'src/components/LoadingSpinner';
import { useFetch } from 'src/hooks/useFetch';
import { Modal } from '../../';
import { RetryMessage } from '../../../RetryMessage';
import ChatBox from './ChatBox';

function VerChatTicketModal(props) {
  const initialLoadRef = useRef(true);
  const { open, close } = props;
  const {
    fetch: fetchLogs,
    loading: loadingLogs,
    data: logs,
    error: errorLoadingLogs,
  } = useFetch();

  const isRequerimiento = /^R-\d+$/.test(props?.data?.codigo);

  const { fetch: sendMessage } = useFetch();

  const onCloseModal = React.useCallback(() => {
    close();
  }, [close]);

  const getMessageLogs = React.useCallback(async () => {
    await fetchLogs(
      `/tickets/${isRequerimiento ? 'requerimientos' : 'incidentes'}/${
        props?.data?.codigo
      }/bitacora`,
    );

    if (initialLoadRef.current) {
      initialLoadRef.current = false;
    }
  }, [fetchLogs, props.data.codigo, isRequerimiento]);

  const sendMessageLog = React.useCallback(
    async (msg) => {
      const data = new URLSearchParams({ mensaje: msg }).toString();
      await sendMessage(
        `/tickets/${isRequerimiento ? 'requerimientos' : 'incidentes'}/${
          props?.data?.codigo
        }/bitacora`,
        { method: 'POST', data },
      );
      getMessageLogs();
    },
    [sendMessage, getMessageLogs, props.data.codigo, isRequerimiento],
  );

  useEffect(() => {
    getMessageLogs();
  }, [getMessageLogs]);

  useEffect(() => {
    const interval = setInterval(getMessageLogs, 5000);

    return () => clearInterval(interval);
  }, [getMessageLogs]);

  const canSendMessages =
    props.data.estado !== ITOP_TICKET_OPERATIONAL_STATUS_MAP.closed;

  const isLoadingChatLogs = !!initialLoadRef.current && loadingLogs;

  return (
    <Modal
      title={`Chat: ${props?.data.codigo}`}
      content={
        <>
          {isLoadingChatLogs && <LoadingSpinner />}
          {!isLoadingChatLogs && errorLoadingLogs && (
            <RetryMessage
              message="Ocurrió un error al intentar cargar la información."
              retry={getMessageLogs}
            />
          )}
          {!isLoadingChatLogs && !errorLoadingLogs && logs && (
            <ChatBox
              messages={logs}
              handleSendMessage={sendMessageLog}
              canSendMessages={canSendMessages}
            />
          )}
        </>
      }
      open={open}
      close={onCloseModal}
      showConfirmButton={false}
      cancelButtonPosition="top"
    />
  );
}

export default VerChatTicketModal;
